import React from 'react';
import ProfileForm from '../components/profile/ProfileForm';
import Alert from '../components/ui/Alert';

const ProfilePage: React.FC = () => {
    return (
        <div className="container">
            <div className="header">
                <h1>👤 User Profile</h1>
                <p>Update your personal information</p>
            </div>

            <div className="form-container">
                <Alert />
                <ProfileForm />
            </div>
        </div>
    );
};

export default ProfilePage;